module.exports = __webpack_public_path__ + "img/Meeting-text.65b85750.jpg";